module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/cm-gallery/cm-gallery-12-614cbf56e0739f954fd793943b96d9a0.jpg";